import supabase from '../supabase/supabase';
import {initialTiles} from './mockData';

const TABLE='tiles_persistent';

const rowToTile=(row)=> ({
  id: row.id,
  x: row.x, y: row.y, w: row.w, h: row.h,
  title: row.title,
  link: row.link,
  image: row.image || '',
  solidColor: row.solid_color || '',
  blockText: row.block_text || '',
  blockTextColor: row.block_text_color || '#ffffff',
  hasGlow: row.has_glow,
  hasGif: row.has_gif,
  isDofollow: row.is_dofollow,
  ownerEmail: row.owner_email,
  clicks: row.clicks || 0,
  referralCode: row.referral_code || '',
  source: row.source || 'direct',
});

const tileToRow=(tile)=> ({
  id: tile.id,
  x: tile.x, y: tile.y, w: tile.w, h: tile.h,
  title: tile.title || '',
  link: tile.link || '',
  image: tile.image || '',
  solid_color: tile.solidColor || '',
  block_text: tile.blockText || '',
  block_text_color: tile.blockTextColor || '#ffffff',
  has_glow: tile.hasGlow || false,
  has_gif: tile.hasGif || false,
  is_dofollow: tile.isDofollow || false,
  owner_email: tile.ownerEmail || '',
  clicks: tile.clicks || 0,
  referral_code: tile.referralCode || '',
  source: tile.source || 'direct',
});

export async function loadTilesFromDb() {
  try {
    const {data,error}=await supabase.from(TABLE).select('*').order('created_at',{ascending:true});
    if (error) throw error;
    if (!data || data.length===0) {
      await seedMockTiles();
      return initialTiles;
    }
    return data.map(rowToTile);
  } catch(err) {
    console.error('loadTilesFromDb failed,using localStorage fallback:',err);
    return null;
  }
}

async function seedMockTiles() {
  try {
    const rows=initialTiles.map(tileToRow);
    const {error}=await supabase.from(TABLE).upsert(rows,{onConflict:'id'});
    if (error) console.error('Seed error:',error);
  } catch(err) {
    console.error('seedMockTiles failed:',err);
  }
}

export async function upsertTileInDb(tile) {
  try {
    const {error}=await supabase.from(TABLE).upsert(tileToRow(tile),{onConflict:'id'});
    if (error) throw error;
    return true;
  } catch(err) {
    console.error('upsertTileInDb failed:',err);
    return false;
  }
}

export async function upsertManyTilesInDb(tiles) {
  try {
    const rows=tiles.map(tileToRow);
    const {error}=await supabase.from(TABLE).upsert(rows,{onConflict:'id'});
    if (error) throw error;
    return true;
  } catch(err) {
    console.error('upsertManyTilesInDb failed:',err);
    return false;
  }
}

export async function deleteTileFromDb(id) {
  try {
    const {error}=await supabase.from(TABLE).delete().eq('id',id);
    if (error) throw error;
    return true;
  } catch(err) {
    console.error('deleteTileFromDb failed:',err);
    return false;
  }
}

export async function deleteAllTilesFromDb() {
  try {
    const {error}=await supabase.from(TABLE).delete().neq('id','__never__');
    if (error) throw error;
    return true;
  } catch(err) {
    console.error('deleteAllTilesFromDb failed:',err);
    return false;
  }
}